// extracted by mini-css-extract-plugin
export default {"fs":"_87339b84bd _281e9287c1"};